// export const BASE_URL = 'http://192.168.1.68:8001/api';
// export const BASE_URL_SOCKET = 'http://192.168.1.68:8001';
// export const BASE_URL = 'https://jsonplaceholder.typicode.com';
// export const BASE_URL = 'http://52.23.254.231:8001/api';
export const BASE_URL = import.meta.env.VITE_APP_BASE_URL;
export const BASE_URL_SOCKET = import.meta.env.VITE_APP_BASE_URL_SOCKET;
